import { useTopicsDataContext } from "app/pages/activation/context/Topics/TopicsDataContext";
import { useTopicsModalContext } from "app/pages/activation/context/Topics/TopicsModalContext";

import { listKeys } from "../automationKeys";
import { MonitorTopicsButton } from "../MonitorTopicsButton/MonitorTopicsButton";
import { Topic } from "../Topic/Topic";

import * as SC from "./styles";

type ListSchema = { isViewerMode: boolean };

export const List = ({ isViewerMode }: ListSchema) => {
    const { data, isLoading, isSuggestion } = useTopicsDataContext();
    const { onCreateTopic } = useTopicsModalContext();

    if (!isLoading && !data) {
        return null;
    }

    return (
        <SC.TopicsList
            data-automation={listKeys.container}
            isDisabled={isSuggestion}
        >
            {data?.map((item, index) => (
                <Topic
                    key={index}
                    data={item}
                    isViewerMode={isViewerMode}
                    isLastTopic={index + 1 === data.length}
                />
            ))}

            {isSuggestion ? (
                <MonitorTopicsButton
                    onClick={onCreateTopic}
                    isViewerMode={isViewerMode}
                />
            ) : null}
        </SC.TopicsList>
    );
};

List.displayName = "List";
